import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { KhuyanaRoutingModule } from 'src/app/khuyana-routing.module';
import { KhuyanaHeaderMenuComponent } from './khuyana-header-menu.component';
import { KhuyanaHeaderSubmenuComponent } from './khuyana-header-submenu.component';
import { KhuyanaHeaderComponent } from './khuyana-header.component';

const HEADER_COMPONENTS: any[] = [
  KhuyanaHeaderComponent,
  KhuyanaHeaderMenuComponent,
  KhuyanaHeaderSubmenuComponent,
];

@NgModule({
  declarations: [...HEADER_COMPONENTS],
  imports: [
    BrowserModule,
    KhuyanaRoutingModule,
    OverlayPanelModule,
    ScrollPanelModule,
    SidebarModule,
  ],
  exports: [...HEADER_COMPONENTS],
})
export class KhuyanaHeaderModule {}
